import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Box, Button, Typography, Modal, Grid, Select } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import ReactSelect from "react-select";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ClaimRegistration from "../ClaimRegistration";
import { useSelector } from "react-redux";
import PatientRegistration from "../PatientRegistration";

const AgingReport = () => {
  const rights = useSelector((state) => state.login.rights);

  const [isLoading, setLoading] = useState(false);
  document.title = "Aging Reports | LuxBilling";
  const [Rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [openClaimModal, setOpenClaimModal] = useState(false);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [PatienTdemoGraphiceId, setPatienTdemoGraphiceId] = useState(null); // 'approve' or 'luxbilling'

  function applyRefresh() {
    setRefresh(!refresh);
  }
  const columns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.2,
      minWidth: 60,
      renderCell: (cellValues) => (
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
          onClick={() => {
            setSelectedClaim(cellValues.row);
            setPatienTdemoGraphiceId(cellValues.row.patientId);
            setOpenClaimModal(true);
          }}
        >{`${cellValues.row.id}`}</Button>
      ),
    },

    {
      field: "patientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
      minWidth: 180,
      // renderCell: cellValues => (
      //   <Button
      //     style={{ display: "flex", justifyContent: "flex-start" }}
      //     size='small'
      //     variant='text'
      //     color='info'
      //     onClick={() => {
      //       setSelectedClaim(cellValues.row);
      //       setOpenClaimModal(true);
      //     }}
      //   >{`${cellValues.row.patientName}`}</Button>
      // )
    },
    {
      field: "insuranceName",
      headerName: "Insurance Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.8,
      minWidth: 150,
    },
    {
      field: "createdDate",
      headerName: "Submitted Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => {
        return params.value ? Moment(params.value).format("MM-DD-YYYY") : "";
      },
    },
    {
      field: "updatedDate",
      headerName: "Last Worked Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => {
        return params.value ? Moment(params.value).format("MM-DD-YYYY") : "";
      },
    },
    {
      field: "ClaimAge",
      headerName: "Claim Age",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: "DaysDue",
      headerClassName: "super-app-theme--header",
      headerName: "Days Due",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
      minWidth: 80,
    },
    {
      field: "amountDue",
      headerClassName: "super-app-theme--header",
      headerName: "Amount Due",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
      minWidth: 80,
    },
    {
      field: "dos",
      headerClassName: "super-app-theme--header",
      headerName: "DOS",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
      minWidth: 80,
      valueFormatter: (params) => {
        return params.value ? Moment(params.value).format("MM-DD-YYYY") : "";
      },
    },
  ];
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };

  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem("default_paractice")
  );
  const [PracticeName, setPracticeName] = useState();
  const [ClaimStatus, setClaimStatus] = useState("all");
  const [selectedRange, setSelectedRange] = useState(null);
  console.log("Selected Range:", selectedRange);
  const filterOptions = [
    { value: "0-30", label: "0-30 days" },
    { value: "31-60", label: "31-60 days" },
    { value: "61-90", label: "61-90 days" },
    { value: "91-120", label: "91-120 days" },
    { value: "120", label: "120+ days" },
  ];
  const statusOptions = [
    { value: "all", label: "All" },
    { value: "new", label: "🔴New" },
    { value: "pending", label: "🟠Pending" },
    { value: "secondaryPending", label: "🟤Secondary Pending" },
    { value: "pendingFurtherProcess", label: "🟣Pending further Process" },
    // { value: "completed", label: "🟢Completed" },
    // { value: "paid", label: "🔵Paid" },
    { value: "partiallyPaid", label: "💠Partially Paid" },
    // { value: "closed", label: "⚫Closed" },
  ];
  const handleStatusChange = (selectedOption) => {
    setSelectedRange(selectedOption.value);
  };
  const handleStatusChangeStatus = (selectedOption) => {
    setClaimStatus(selectedOption.value);
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/claims/UnpaidClaimsStatus?tokenPracticeId=${selectedOption}&age=${selectedRange}&status=${ClaimStatus} `,
        {
          headers,
        }
      )
      .then((response) => {
        setRows(response);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [refresh, selectedOption, ClaimStatus, selectedRange]);
  const [Practices, setPractices] = useState(null);
  const Emailaddress = localStorage.getItem("Emailaddress");

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/UserPractices/getUserPractices?userEmail=${Emailaddress}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        const bprov = response.map((field) => ({
          label: field.practiceName,
          value: field.practiceId,
        }));
        setPractices(bprov);
      })
      .catch((error) => {
        console.error("Error fetching referring physicians:", error);
      });
  }, [refresh]);
  useEffect(() => {
    if (Practices && selectedOption) {
      const selected = Practices.find(
        (option) => option.value == selectedOption
      );
      if (selected) {
        setPracticeName(selected.label);
      }
    }
  }, [Practices, selectedOption]);

  // const handleDownload = async () => {
  //   const doc = new jsPDF();
  //   const margin = 10;
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   const drawFirstPageHeader = () => {
  //     const title = 'Aging Report';
  //     doc.setTextColor(0, 102, 204);
  //     doc.setFontSize(19);
  //     doc.setFont('helvetica', 'bold');
  //     const titleWidth = doc.getTextWidth(title);
  //     const titleX = (pageWidth - titleWidth) / 2; // Centering the title
  //     const titleY = 20;
  //     doc.text(title, titleX, titleY);
  //     doc.setFont('helvetica', 'normal');
  //     doc.setTextColor(0, 0, 0);
  //   };
  //   const drawBorder = () => {
  //     doc.setDrawColor(0, 0, 0);
  //     doc.rect(margin, margin, pageWidth - margin * 2, pageHeight - margin * 2); // Border dimensions
  //   };
  //   drawFirstPageHeader();
  //   drawBorder();
  //   let yPosition = 30;
  //   const columns = [
  //     { header: 'ID', dataKey: 'id' },
  //     { header: 'Patient Name', dataKey: 'patientName' },
  //     { header: 'Insurance Name', dataKey: 'insuranceName' },
  //     { header: 'Claim Age', dataKey: 'ClaimAge' },
  //     { header: 'Days Due', dataKey: 'DaysDue' },
  //     { header: 'Amount Due', dataKey: 'amountDue' },
  //     { header: 'Dos', dataKey: 'dos' },
  //   ];

  //   const rows = Rows.map(item => ({
  //     id: item.id,
  //     patientName: item.patientName,
  //     insuranceName: item.insuranceName,
  //     ClaimAge: item.ClaimAge,
  //     DaysDue: item.DaysDue,
  //     amountDue: item.amountDue,
  //     dos: item.dos,
  //   }));

  //   doc.autoTable({
  //     head: [columns.map(col => col.header)],
  //     body: rows.map(item => Object.values(item)),
  //     startY: yPosition, // Start table below therapist's report text
  //     margin: { top: margin + 5, bottom: margin + 5 }, // Padding for table within border

  //     didDrawPage: (data) => {
  //       drawBorder(); // Draw border on every page
  //     },
  //   });

  //   // Define filename and save
  //   const fileName = `Aging_Report_${Moment(new Date()).format('DD_MMM_YY')}.pdf`;
  //   doc.save(fileName);
  // };
  // const handleDownload = () => {
  //   const doc = new jsPDF({
  //     orientation: 'p',
  //     unit: 'mm',
  //     format: [230, 297], // Wider than A4
  //   });
  //   // portrait, millimeters, A4
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   const currentDate = Moment().format('MMMM Do YYYY, h:mm A');

  //   const addHeader = () => {
  //     // Title
  //     doc.setFontSize(14);
  //     doc.setFont('helvetica', 'bold');
  //     const title = 'Unpaid Claims Report';
  //     doc.text(title, pageWidth / 2, 15, { align: 'center' });

  //     // Practice Name
  //     if (PracticeName) {
  //       doc.setFontSize(11);
  //       doc.setFont('helvetica', 'normal');
  //       doc.text(`Practice: ${PracticeName}`, pageWidth / 2, 21, { align: 'center' });
  //     }

  //     // Export Date
  //     doc.setFontSize(9);
  //     doc.text(`Exported on: ${currentDate}`, pageWidth / 2, 27, { align: 'center' });
  //   };

  //   addHeader(); // First page

  //   const tableColumn = columns.map((col) => col.headerName);
  //   const tableRows = Rows.map((row) =>
  //     columns.map((col) => {
  //       let value = row[col.field];
  //       if (col.valueFormatter) {
  //         value = col.valueFormatter({ value });
  //       }
  //       return value ?? '';
  //     })
  //   );

  //   autoTable({
  //     startY: 30,
  //     head: [tableColumn],
  //     body: tableRows,
  //     styles: {
  //       fontSize: 8.2,
  //       cellPadding: 3,
  //       overflow: 'linebreak',
  //       valign: 'middle',
  //     },
  //     headStyles: {
  //       fillColor: [55, 117, 98],
  //       textColor: 255,
  //       fontSize: 9.5,
  //       halign: 'center',
  //     },
  //     bodyStyles: {
  //       halign: 'justify',
  //       textColor: 30,
  //       minCellHeight: 7,
  //     },
  //     alternateRowStyles: {
  //       fillColor: [245, 245, 245],
  //     },
  //     margin: { top: 30, bottom: 20 },
  //     didDrawPage: (data) => {
  //       addHeader(); // repeated on every page
  //       // Footer
  //       const str = `Page ${doc.internal.getCurrentPageInfo().pageNumber}`;
  //       doc.setFontSize(8);
  //       doc.text(str, pageWidth - 20, pageHeight - 10);
  //     },
  //   });

  //   doc.save('Aging_Report.pdf');
  // };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [230, 297], // Custom page size
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const currentDate = Moment().format("MMMM Do YYYY, h:mm A");

    const addHeader = () => {
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      const title = "Unpaid Claims Report";
      doc.text(title, pageWidth / 2, 15, { align: "center" });

      if (PracticeName) {
        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");
        doc.text(`Practice: ${PracticeName}`, pageWidth / 2, 21, {
          align: "center",
        });
      }

      doc.setFontSize(9);
      doc.text(`Exported on: ${currentDate}`, pageWidth / 2, 27, {
        align: "center",
      });
    };

    addHeader(); // First page

    const tableColumn = columns.map((col) => col.headerName);
    const tableRows = Rows.map((row) =>
      columns.map((col) => {
        let value = row[col.field];
        if (col.valueFormatter) {
          value = col.valueFormatter({ value });
        }
        return value ?? "";
      })
    );

    // ✅ Use autoTable(doc, config)
    autoTable(doc, {
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      styles: {
        fontSize: 8.2,
        cellPadding: 3,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [55, 117, 98],
        textColor: 255,
        fontSize: 9.5,
        halign: "center",
      },
      bodyStyles: {
        halign: "justify",
        textColor: 30,
        minCellHeight: 7,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      margin: { top: 30, bottom: 20 },
      didDrawPage: () => {
        addHeader(); // repeated header
        const str = `Page ${doc.internal.getCurrentPageInfo().pageNumber}`;
        doc.setFontSize(8);
        doc.text(str, pageWidth - 20, pageHeight - 10);
      },
    });

    doc.save("Aging_Report.pdf");
  };

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    padding: 0,
  };

  const scrollableBodyStyle = {
    flex: 1,
    overflowY: "auto",
    padding: "16px",
  };
  const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const styleDetailspatient = {
    width: "90%",
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    zIndex: 1500, // 🔥 This makes sure the modal stays on top
    scrollbarWidth: "thin",
    scrollbarColor: "#356F60 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4,
    },
  };
  return (
    <div className="page-content">
      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        sx={{ zIndex: 1500 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: "-90px" }}>
              <PatientRegistration
                callingFrom={"Authorization"}
                pid={PatienTdemoGraphiceId}
                handleClosepatientreg={handleClosepatientreg}
              ></PatientRegistration>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openClaimModal}
        onClose={() => setOpenClaimModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            width: { xs: "95%", sm: "90%", md: "80%", lg: "70%" },
            maxHeight: "90vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Headroom>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: "#356F60",
                position: "sticky",
                top: 0,
                zIndex: 10,
                px: { xs: 1.5, sm: 2 },
                py: { xs: 1, sm: 1.5 },
              }}
            >
              {/* Title */}
              <Grid item xs={12} sm={7} md={8.5}>
                <DialogTitle
                  sx={{
                    textAlign: { xs: "center", sm: "left" },
                    fontSize: { xs: "18px", sm: "22px", md: "25px" },
                    fontWeight: "bold",
                    color: "#fff",
                    p: 0,
                  }}
                >
                  Claim Details
                </DialogTitle>
              </Grid>

              {/* Go to Patient Chart Button */}
              <Grid
                item
                xs={8}
                sm={3.5}
                md={3}
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: { xs: "center", sm: "flex-start" },
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <Button
                  variant="contained"
                  color="info"
                  fullWidth
                  size="small"
                  onClick={() => setOpenpatientreg(true)}
                  sx={{
                    height: "32px",
                    fontSize: { xs: "0.75rem", sm: "0.8rem" },
                    whiteSpace: "nowrap",
                  }}
                >
                  Go to Patient Chart
                </Button>
                <CancelOutlinedIcon
                  onClick={() => setOpenClaimModal(false)}
                  fontSize="large"
                  sx={{
                    color: "red",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                  }}
                />
              </Grid>

              {/* Close Icon - fixed position in header */}
            </Grid>
          </Headroom>

          {/* Scrollable Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: { xs: 1.5, sm: 2 },
              backgroundColor: "#fafafa",
            }}
          >
            <ClaimRegistration
              claimId={selectedClaim ? selectedClaim.id : null}
              Namee={selectedClaim ? selectedClaim.patientName : null}
              patientName={selectedClaim ? selectedClaim.patientName : null}
              claimPracticeID={selectedOption}
              claimpatientId={selectedClaim ? selectedClaim.patientId : null}
              patientId={selectedClaim ? selectedClaim.patientId : null}
              AgingReportView={true}
              applyRefresh={applyRefresh}
              CloseModal={() => setOpenClaimModal(false)}
            />

          </Box>
        </Box>
      </Modal>

      <Container>
        <Grid container spacing={2}>
          {/* Practice Name Dropdown */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: { xs: "100%", sm: "auto" }, // Full width on mobile
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                mb: 0.5,
                fontWeight: "bold",
                fontSize: "18px",
                color: "black",
              }}
            >
              Practice Name
            </Typography>
            <ReactSelect
              options={Practices}
              value={
                Practices?.find(
                  (option) =>
                    option.value === selectedOption ||
                    option.value?.toString() === selectedOption?.toString()
                ) || null
              }
              onChange={(option) => {
                setSelectedOption(option.value);
                setPracticeName(option.label);
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  height: "40px",
                  minWidth: "100%",
                  maxWidth: "100%",
                  zIndex: 1,
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                menu: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  marginBottom: "10px",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#aec3b0",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#8B4513",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f5f5f5",
                  },
                }),
              }}
              placeholder="Select Practice"
              aria-label="Select Practice Name"
            />
          </Grid>

          {/* Status Dropdown */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                mb: 0.5,
                fontWeight: "bold",
                fontSize: "18px",
                color: "black",
              }}
            >
              Status
            </Typography>
            <ReactSelect
              options={statusOptions}
              value={statusOptions.find(
                (option) => option.value === ClaimStatus
              )}
              onChange={handleStatusChangeStatus}
              // styles={{
              //   control: (base) => ({
              //     ...base,
              //     height: "40px",
              //     minWidth: "100%",
              //     maxWidth: "100%",
              //     zIndex: 1,
              //   }),
              //   menuPortal: (base) => ({
              //     ...base,
              //     zIndex: 9999,
              //   }),
              //   menu: (base) => ({
              //     ...base,
              //     maxHeight: "200px",
              //     overflowY: "auto",
              //   }),
              //   menuList: (base) => ({
              //     ...base,
              //     maxHeight: "200px",
              //     marginBottom: "10px",
              //     "&::-webkit-scrollbar": {
              //       width: "6px",
              //     },
              //     "&::-webkit-scrollbar-thumb": {
              //       backgroundColor: "#aec3b0",
              //       borderRadius: "10px",
              //     },
              //     "&::-webkit-scrollbar-thumb:hover": {
              //       backgroundColor: "#8B4513",
              //     },
              //     "&::-webkit-scrollbar-track": {
              //       backgroundColor: "#f5f5f5",
              //     },
              //   }),
              // }}
              placeholder="Select Status"
              aria-label="Select Status"
            />
          </Grid>

          {/* Claim Age Dropdown */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              minWidth: { xs: "100%", sm: "auto" },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                mb: 0.5,
                fontWeight: "bold",
                fontSize: "18px",
                color: "black",
              }}
            >
              Claim Age
            </Typography>
            <ReactSelect
              options={filterOptions}
              value={filterOptions.find((opt) => opt.value === selectedRange)}
              onChange={handleStatusChange}
              styles={{
                control: (base) => ({
                  ...base,
                  height: "40px",
                  minWidth: "100%",
                  maxWidth: "100%",
                  zIndex: 1,
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                menu: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  marginBottom: "10px",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#aec3b0",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#8B4513",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f5f5f5",
                  },
                }),
              }}
              placeholder="Select Range"
              aria-label="Select Claim Age Range"
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            mt: "5px",
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "10px",
          }}
        >
          {rights.Download_AgingReport && (
            <Button
              className="Button"
              onClick={handleDownload}
              disabled={!Rows || Rows.length === 0}
              variant="contained"
            >
              <DownloadForOfflineIcon
                fontSize="small"
                style={{
                  color: "white",
                  paddingRight: "4px",
                  paddingBottom: "2px",
                }}
              ></DownloadForOfflineIcon>
              Download
            </Button>
          )}
        </Grid>

        <Box mb={3} marginTop={2} style={{ marginTop: "5px" }}>
          {isLoading ? (
            <div style={{ margin: "5rem", textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <div style={{ height: 400, width: "100%" }}>
              {Rows === null || Rows.length === 0 ? (
                <Typography>No Record found</Typography>
              ) : (
                <DataGrid
                  rows={Rows}
                  classes={gridClasses}
                  columns={columns}
                  pagination
                  pageSizeOptions={[25]}
                  sx={gridRowStyle}
                  rowHeight={30}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 100, page: 0 },
                    },
                  }}
                />
              )}
            </div>
          )}
        </Box>
      </Container>
    </div>
  );
};

export default AgingReport;
